<template>
  <div>
    <Card>
      <template slot="header">Terms of Use</template>
      <v-layout
        justify-center
        column>
        <p v-html="settings.textTos"/>
        <v-layout>
          <v-btn
            color="red"
            dark
            @click="$router.go(-1)"
          >
            Back
          </v-btn>
          <v-btn :to="{path: '/checkout/payment'}">
            Agree and Continue
          </v-btn>
        </v-layout>
      </v-layout>
    </Card>
  </div>
</template>

<script>
export default {
}
</script>
